export default "__VITE_ASSET__CU11ej9J__"